

















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import AdvisoryFunds from "@/shared/components/investments/drivewealth/AdvisoryFunds.vue";

import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import OpenBrokerageSearch from "@/shared/components/investments/drivewealth/OpenBrokerageSearch.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import { FetchState, DrivewealthAccountManagementType } from "@/shared/types";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useRiskToleranceQuestionnaireStore } from "@/shared/store/riskToleranceQuestionnaire";

@Component({
  components: {
    AdvisoryFunds,
    DrivewealthNavigation,
    GenericLoadingSpinner,
    RiskDisclaimer,
    OpenBrokerageSearch,
    AccountTypeSubheader
  }
})
export default class AvailableInvestmentsPage extends Vue {
  @Prop({ required: false }) username: string;

  @Prop({ required: false }) partnerId: number;

  @Prop({ required: false }) accountId: number;

  drivewealth = useDrivewealthStore();
  riskToleranceQuestionnaireStore = useRiskToleranceQuestionnaireStore();
  isCuratedRtqAccountType = false;
  loaded = false;

  mounted () {
    this.loaded = false;
    if (this.accountId) {
      this.drivewealth.getAccountSummaryV2({ username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId })
      .then(() => {
        const accountSummary = this.drivewealth.accountSummaryById(this.accountId);
        this.isCuratedRtqAccountType = accountSummary.isCuratedRtqAccountType;
        if (this.riskToleranceQuestionnaireStore.isRtqUpdated) {
          this.riskToleranceQuestionnaireStore.setFetchState(FetchState.Uninitialized);
          this.riskToleranceQuestionnaireStore.getRiskToleranceQuestionnaireResults()
              .then(() => {
                this.drivewealth.loadCuratedRtqInstruments({
                  username: this.username,
                  partnerId: this.partnerId,
                  instrumentListId: this.riskToleranceQuestionnaireStore.instrumentListId,
                  force: true
                });
              });
        }
        this.loaded = true;
      });
    }
  }

  get isLoaded () {
    return this.loaded;
  }

  get showAdvisoryFunds () {
    const accountSummary = this.drivewealth.accountSummaryById(this.accountId);
    return accountSummary
        && accountSummary.accountManagementType === DrivewealthAccountManagementType.Advisory;
  }

  get showOpenBrokerage () {
    const accountSummary = this.drivewealth.accountSummaryById(this.accountId);
    return accountSummary && accountSummary.accountManagementType === DrivewealthAccountManagementType.OpenBrokerage;
  }
}
